import { getCostCenterByMarket } from "Store/Organization/CostCenterByMarket/CostCenterByMarketAction"
import { getCostCenterBySearchString } from "Store/Organization/CostCenters/CostCentersAction"
import { getMarketDropDown } from "Store/Organization/Market/MarketAction"
import moment from "moment"

const fetchGridData = (costCenter: any, dateRange: any, paginationData: any, sortData: any, userEmail: string, sagaGridFunction: (payload: any)=>void, dispatch: (payload: any) => void, isApprovalHistory: boolean) => {
    let payload: any = {}
    
    if (!isApprovalHistory) {
      payload = {
        pageNumber: paginationData?.pageIndex != undefined ? paginationData?.pageIndex + 1 : 1,
        pageSize: paginationData?.pageSize ? paginationData?.pageSize : 10,
        entityId: parseInt(costCenter?.id),
        entityType: costCenter?.type
      }
    }else{
      payload = {
        pageNumber: paginationData?.pageIndex != undefined ? paginationData?.pageIndex + 1 : undefined,
        pageSize: paginationData?.pageSize,
        columnFilters: [],
        loggedInMail: userEmail,
        globalSearchField: costCenter?.type,
        globalSearchValue: costCenter?.id,
      }
    }

    let fromDate: any = ''
    let toDate: any = ''

    if (dateRange?.length) {
      for (let i = 0; i < dateRange?.length; i++) {
        let val = dateRange[i].toString();
        let date = moment(new Date(val)).format('YYYY-MM-DD');
        if (i == 0) {
          fromDate = date;
        } else {
          toDate = date;
        }
      }
    }
    if (fromDate != '' && toDate != '') {
      payload.fromDate = fromDate;
      payload.toDate = toDate
    }

    if (sortData?.key != '') {
      payload.sortBy = sortData?.key;
      payload.sortOrder = sortData?.sortDirection;
    }
    dispatch(sagaGridFunction(payload))
  }

  const handleChange = (value: any, name: string, setFilterFunction: (payload: any) => void, filterValues: any, setShowGrid: (payload: boolean) => void, dispatch: (payload: any) => void) => {

    switch (name) {
      case "region":
        dispatch(getMarketDropDown(value?.key))
        dispatch(setFilterFunction({
          ...filterValues,
          region: value,
          market: '',
          costCenter: '',
          searchedCostCenter: '',
        }))
        setShowGrid(false)
        break;
      case "market":
        dispatch(getCostCenterByMarket({marketId : value?.key},true))
        dispatch(setFilterFunction({
          ...filterValues,
          market: value,
          costCenter: '',
          searchedCostCenter: '',
        }))
        setShowGrid(false)
        break;
      case "costCenter":
        dispatch(setFilterFunction({ ...filterValues, costCenter: value, searchedCostCenter: '' }))
        setShowGrid(false)
        break;
      default:
        break;
    }
  }

  const searchCostCenter = (value: any, action: any, dispatch: (payload: any) => void) => {
    if (action.action === "input-change") {
      dispatch(getCostCenterBySearchString(value,true))
    }
  };

  const handleChangeSearchedCostCenter = (value: any, setFiltersFunction: (payload: any) => void, filterValues: any, userEmail: string, sagaGridFunction: (payload: any)=>void, setShowGrid: (payload: boolean) => void, dispatch: (payload: any) => void, isApprovalHistory: boolean ) => {
    dispatch(setFiltersFunction({ ...filterValues, searchedCostCenter: value, costCenter: '', region: '', market: '' }))
    fetchGridData({type: "CostCenter", id: value?.value}, filterValues?.dateRange, filterValues?.paginationData, filterValues?.sortData, userEmail, sagaGridFunction, dispatch, isApprovalHistory)
    setShowGrid(true)
  }

  const onDateChange = (date: any, setFiltersFunction: (payload: any) => void, filterValues: any, userEmail: string, sagaGridFunction: (payload: any)=>void, dispatch: (payload: any) => void, isApprovalHistory: boolean, costCenterValue: any) => {
    dispatch(setFiltersFunction({ ...filterValues, dateRange: date }))
    if(costCenterValue?.type){
    fetchGridData(costCenterValue, date, filterValues?.paginationData, filterValues?.sortData, userEmail, sagaGridFunction, dispatch, isApprovalHistory)
    }
  }

  export {
    searchCostCenter,
    handleChangeSearchedCostCenter,
    onDateChange,
    fetchGridData,
    handleChange
  }